import FileUploadDragger from './FileUploadDragger';

export default FileUploadDragger;
